module.exports = __webpack_public_path__ + "img/map_mezzanine.c97f307d.jpg";